module.exports = __webpack_public_path__ + "img/LUB00178.ea413209.png";